import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur länge kan ett tillfälligt serveringstillstånd gälla?";
const SHORT_ANSWER = "Tillfälligt tillstånd avser enstaka tidsperiod eller tillfälle – från en kväll upp till en sammanhängande sommarsäsong i särskilda fall.";

export const Route = createFileRoute("/fraga/hur-lange-far-tillfalligt-tillstand-vara")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur länge kan ett tillfälligt serveringstillstå…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Vid återkommande verksamhet på samma plats kräver kommunen normalt stadigvarande tillstånd. Använd inte tillfälligt tillstånd som 'permanent' lösning för restaurangdrift."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/tillfalligt-serveringstillstand", label: "Tillfälligt tillstånd – tidsramar" }}
      related={[{"to": "/fraga/far-jag-foreningens-arsfest-utan-tillstand", "label": "Behöver föreningen tillstånd för årsfest med vin?"}, {"to": "/fraga/far-jag-ha-tillstand-utan-fysisk-lokal", "label": "Kan jag få serveringstillstånd utan fast lokal?"}, {"to": "/fraga/behover-mojligheten-kommunens-godkannande-i-forvag", "label": "Måste evenemangsplats godkännas i förväg?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur länge kan ett tillfälligt serveringstillstånd gälla?" },
      { name: "description", content: "Tillfälligt tillstånd avser enstaka tidsperiod eller tillfälle – från en kväll upp till en sammanhängande sommarsäsong i särskilda fall." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-lange-far-tillfalligt-tillstand-vara" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-lange-far-tillfalligt-tillstand-vara" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-lange-far-tillfalligt-tillstand-vara",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur länge kan ett tillfälligt serveringstillstå…", url: "https://alkoholprovet.se/fraga/hur-lange-far-tillfalligt-tillstand-vara" },
      ]),
    ],
  }),
});
